export default "__VITE_ASSET__4713d1d5__"